import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { IAboutSectionProps } from './interfaces';
import SanityText from '@components/Shared/SanityText';
import SanityImage from '@components/Shared/SanityImage';

const AboutSection: React.FC<IAboutSectionProps> = ({
  image,
  text,
  reverse,
  ...rest
}) => {
  return (
    <Flex
      justify="space-between"
      align="center"
      direction={
        reverse
          ? ['column-reverse', null, 'row-reverse']
          : ['column', null, 'row']
      }
      sx={{ '& h3': { marginBottom: '42px' } }}
      {...rest}
    >
      <SanityText
        content={text}
        w={['100%', null, '47%']}
        mt={reverse ? [10, null, 0] : 0}
        mb={reverse ? 0 : ['30px', null, 0]}
      />
      <Box w={['100%', null, '47%']}>
        <SanityImage
          sanityImage={image}
          height={536}
          width={536}
          layout="responsive"
        />
      </Box>
    </Flex>
  );
};

export default AboutSection;
